import { UserGroupId } from "@sp-crm/core";
import { useGetUserGroupsQuery } from "generated/graphql";
import { useMemo } from "react";
import { stableQueryOptions } from "util/requests";
import { SpMultiSelectOption } from "./sp-multi-select";

export function useGroupOptions(): SpMultiSelectOption<UserGroupId>[] {
    const query = useGetUserGroupsQuery(undefined, stableQueryOptions());

    return useMemo(() => {
        const groups = query.data?.getUserGroups ?? [];
        return groups.map(group => ({ id: group.id, label: group.name }));
    }, [query.data]);
}
